// owner/screens/unit/UnitBookings.js — a unit's bookings tab: the shared owner bookings list (search + status chips,
// latest check-in first, 20 at a time) with the unit fixed. Same filter bar and row as /bookings, built once
// (screens/bookings/BookingsList.js; Adil, 4 Nov 2026).

import React from 'react';
import useLanguage from '../../../hooks/useLanguage';
import { useOwnerBookings, BookingFilters, BookingRows } from '../bookings/BookingsList';

const UnitBookings = ({ unitId }) => {
  const { t } = useLanguage();
  const state = useOwnerBookings(unitId);
  return (
    <>
      <BookingFilters state={state} searchHint={t('ownerApp.bookings.searchInUnit')} />
      <BookingRows state={state} />
    </>
  );
};

export default UnitBookings;
